import React from 'react'
import Field from '../Field/Field.jsx'

const NumberField = (props) =>
	<Field type="number" {...props} />

export default NumberField



// WEBPACK FOOTER //
// ./src/js/Ui/NumberField/NumberField.jsx